const isAccountLinkDisabledForAClient = (clientId: string) => {
  const clients = ['virgin', 'jcrew', 'cathay']
  return clients.includes(clientId)
}

export default isAccountLinkDisabledForAClient
